import styled from 'styled-components';

export const SectionFreeZoneBlock = styled.div`
  padding: 50px 0;
  background-color: #f7f7f7;
`;

export const SectionCaption = styled.div`
  position: relative;
  text-align: center;

  h2 {
    color: #4a4a4a;

    @media (max-width: 767.98px) {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 1rem;
    }
  }

  p {
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif' : 'DINRegular')};
    font-size: 16px;
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.29px')};
    line-height: 20px;
    color: #4a4a4a;

    @media (min-width: 768px) {
      font-size: 16px !important;
    }

    @media (max-width: 767.98px) {
      font-size: 13px;
      letter-spacing: normal;
      line-height: 20px;
      color: #898989;
      margin: 0;
    }
  }
`;

export const FreeZoneIcons = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 0 0;

  &.freezone_icns {
    .service_part {
      padding-right: 0px;
    }
  }
`;

export const ServicePart = styled.div`
  width: 50%;
  display: flex;
  padding: 3rem 1rem 0;

  @media (max-width: 991.98px) {
    padding-left: 7% !important;
  }

  @media (max-width: 575.98px) {
    border: none !important;
    width: 100%;
    display: block;
    text-align: center;
    padding: 3rem 0 0;
  }

  &[dir='ltr'] {
    padding-left: 10% !important;
    padding-right: 0;
    @media (max-width: 767.98px) {
      padding-left: 7% !important;
    }
    @media (max-width: 575.98px) {
      padding-left: 0% !important;
    }
  }

  &[dir='rtl'] {
    padding-right: 10% !important;
    padding-left: 0;
    @media (max-width: 767.98px) {
      padding-left: 0 !important;
    }
    @media (max-width: 575.98px) {
      padding-right: 0% !important;
      padding-left: 7% !important;
    }
  }

  &:nth-of-type(odd) {
    justify-content: flex-end;

    &[dir='ltr'] {
      padding-right: 10% !important;
      padding-left: 0;
      border-right: 1px solid #d8d8d8;
      @media (max-width: 767.98px) {
        padding-left: 0 !important;
      }
      @media (max-width: 575.98px) {
        padding-right: 0% !important;
      }
    }

    &[dir='rtl'] {
      padding-left: 10% !important;
      padding-right: 0;
      border-left: 1px solid #d8d8d8;
      @media (max-width: 767.98px) {
        padding-right: 0 !important;
      }
    }

    @media (max-width: 991.98px) {
      padding-right: 7% !important;
    }

    @media (max-width: 575.98px) {
      padding: 3rem 0 0;
      justify-content: center;
      padding-right: 0% !important;
    }

    div[class*='FreeZoneServicestyled__FZoneDetails-'] {
      width: 210px;

      @media (max-width: 1199.98px) {
        width: 190px;
      }
      @media (max-width: 576px) {
        width: auto;
      }
    }
  }
`;

export const FZoneIcon = styled.div`
  width: 3rem;
  height: 80px;

  &[dir='ltr'] {
    margin-right: 1rem;
    @media (max-width: 575.98px) {
      margin-right: auto;
    }
  }

  &[dir='rtl'] {
    margin-left: 1rem;
    @media (max-width: 575.98px) {
      margin-left: auto;
    }
  }

  @media (max-width: 575.98px) {
    height: 50px;
    margin: 0 auto;
  }
`;

export const FZoneDetails = styled.div`
  h3 {
    margin-bottom: 5px;
    text-decoration: none !important;

    @media (max-width: 1199.98px) {
      font-size: 18px;
    }

    @media (max-width: 767.98px) {
      font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
    }
  }

  p {
    margin-bottom: 0;
    color: #898989;
  }
`;
